@if (appScope.isAuthenticated$ | async) {
  <mat-toolbar class="header-toolbar">
    <div class="brand">
      <div class="header-left">
        @if (appScope.userOnboarded | async) {
          <button (click)="appScope.toggleSideNav();"
            class="sidenav-closed" mat-button data-testid="page-menu-button">
            <i class="fa fa-bars"></i>
          </button>
        }
        <div style="height:100%;">
          <a [routerLink]="accountService.default_url" matTooltip="Home page"><img [src]="loginImgSrc()" alt="login"/></a>
        </div>
        @if (appScope.userOnboarded | async) {
          <account-picker class="account-picker"></account-picker>
        }
      </div>
      <div class="header-center">
        <h1 class="page-title-header">{{headerData.titleSubject | async}}</h1>
      </div>
      <div class="right-mat-menu header-right">
        @if (headerData.show_dtp) {
          <button class="toggle-dtp" mat-button>
            <i (click)="headerData.dtp_visible=!headerData.dtp_visible" class="fa fa-clock"></i>
          </button>
        }
        @if ( appScope.current_user && appScope.isNotMobile) {
          <button [matMenuTriggerFor]="right_mat_menu"
            class="user-menu combo" mat-button>
            {{username()}}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
        }
        @if (appScope.current_user && !appScope.isNotMobile) {
          <button [matMenuTriggerFor]="right_mat_menu"
            mat-button><i class="fas fa-user"></i></button>
          }
          <mat-menu #right_mat_menu="matMenu" backdropClass="header-menu-backdrop" class="header-menu tree-node-menu dark">
            @for (item of right_menu.items; track item.name) {
              @if (item.func && !item.link && item.name) {
                <a (click)="item.func()"
                mat-menu-item>{{item.name}}</a>
              }
              @if (item.angular_page && item.link && item.name) {
                <a
                [routerLink]="item.link" mat-menu-item>{{item.name}}</a>
              }
              @if (!item.angular_page && item.link && item.name && item.name !=='Logout') {
                <a
                [href]="item.link" mat-menu-item target="{{item.name==='My Account' ? '_self':'_blank'}}">{{item.name}}</a>
              }
              @if (!item.link && !item.name) {
                <div
                  style="pointer-events: none; cursor: default; padding: 0 6px">
                  <hr [className]="item.style_class" style="border: 0; height: 1px; background-color: #dbd3d2"/>
                </div>
              }
            }
          </mat-menu>
          <img [attr.src]='rightLogoSrc()' class="client_logo" >
        </div>
      </div>
    </mat-toolbar>
  }
